module.exports = __webpack_public_path__ + "static/img/3_IMG_20150823_115801-EFFECTS.beb2b1e0.jpg";